import {
    ACTIVE,
    ADTF_ASSET_TYPE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET,
    ALERT_UPDATE_SUCCESS_ASSET_MESSAGE,
    ASSET_CONFIG_ATTRIBUTES, DEFAULT_VENDOR_ATTRIBUTES,
    DEPRECATED, getUpdateAssetMessageAlertWithSite,
    LOADING_FAILED,
    LOADING_STRING
} from "../../../util/Constants";
import {
    chainWalk,
    checkInactiveOrDeprecatedAsset,
    flattenADTFSorterConfig,
    convertTableJsonToAsset,
    deepCopyObject,
    getAssetLabelFromMac,
    getNodeId,
    logOperationalMetric,
    preserveAssetConfigAttributes,
    setAliasToRequest,
    getAliasFromParent, isResponseCode5xx,
} from "../../../util/Util";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset,
    updateAssetInPlace
} from "../../../resources/AssetResource";
import {
    updateConfigurationsInAdtfAssetObject
} from "../datamodel/AdtfAssetModelResource";
import {getAdtfDeviceStatus} from "../../../resources/StatusResource";

const ADTF_CONFIG_ATTRIBUTES = ASSET_CONFIG_ATTRIBUTES[ADTF_ASSET_TYPE];

const metricProcessName = "ADTF_DEVICE_DETAILS";

export function refreshAdtfDeviceData(dispatcher, assetSubtype) {
    if (assetSubtype) {
        fetchAdtfSubTypeDeviceDetails(dispatcher, assetSubtype);
    } else {
        fetchAdtfDeviceDetails(dispatcher);
    }
}

export function fetchAdtfSubTypeDeviceDetails(dispatcher, assetSubType) {
    const request = {
        nodeId: getNodeId(),
        assetType: ADTF_ASSET_TYPE
    }
    getAdtfDeviceSubTypeDetails(dispatcher, request, assetSubType)
}

export function fetchAdtfDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: ADTF_ASSET_TYPE
    }
    getAdtfDeviceDetails(dispatcher, request)
}

export function fetchAdtfStatusDetails(dispatcher, model) {
    getAdtfDeviceStatusDetails(dispatcher, model)
}

export function deleteAdtfDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedAdtfDeviceDetails(dispatcher, request)
}

export function setAdtfDeviceDetails(dispatcher, stateValues, showCustomAlert, assetSubtype) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, ADTF_ASSET_TYPE, ACTIVE, assetSubtype);
    addAdtfDeviceDetails(dispatcher, request, showCustomAlert, assetSubtype)
}

export function updateAdtfDeviceDetails(dispatcher, stateValues, showCustomAlert, assetSubtype) {
    const request = convertTableJsonToAsset(stateValues, ADTF_ASSET_TYPE, ACTIVE, assetSubtype);
    updateAdtfAsset(dispatcher, request, showCustomAlert, assetSubtype);
}

export async function updateAdtfDeviceMac(dispatcher, stateValues, mac, showCustomAlert, assetSubtype) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        showCustomAlert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addAdtfDeviceDetails", false, false);
    } else {
        deleteAdtfDeviceDetails(dispatcher, mac);
        setAdtfDeviceDetails(dispatcher, stateValues, showCustomAlert, assetSubtype);
    }
}

async function getAdtfDeviceSubTypeDetails(dispatcher, request, assetSubType) {
    let pageToken = null;
    let assetDeviceDetailList = [];
    const startTime = Date.now();
    let isSuccess = true
    let isFault = false
    
    // Get assets
    do {
        const getAssetsResult = await getAssets(request.nodeId, request.assetType, pageToken)
        const assetListResponse = chainWalk(() => getAssetsResult.data.assetDetailsList, []);
        assetDeviceDetailList = assetDeviceDetailList.concat(assetListResponse)
        isSuccess = getAssetsResult.status === 200;
        isFault = isResponseCode5xx(getAssetsResult.status)
        pageToken = chainWalk(() => getAssetsResult.data.pageToken, null);
    } while (pageToken);

    // Extract data filtered by assetSubType
    const model = extractAdtfSubTypeInformation(assetDeviceDetailList, assetSubType);
    model.sorterConfig = {};
    model.sorterTestPackageConfig = {};

    // Fetch static asset details
    // await getADTFDeviceStaticDetails(dispatcher, model, request);

    // Fetch asset status details
    await getAdtfDeviceStatusDetails(dispatcher, model)
    
    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAdtfComponentDetails", isSuccess, isFault);
}

async function getAdtfDeviceDetails(dispatcher, request) {
    const model = {
        adtfDeviceInformation: {},
        sorterConfig: {},
        sorterTestPackageConfig: {},
        macAddressArray: []
    }

    // Fetch static asset details
    await getADTFDeviceStaticDetails(dispatcher, model, request);
    // Fetch asset status details
    await getAdtfDeviceStatusDetails(dispatcher, model)
}

const extractAdtfSubTypeInformation = (assetDeviceDetailList, assetSubType) => {
    const model = {
        adtfDeviceInformation: {},
        sorterConfig: {},
        sorterTestPackageConfig: {},
        macAddressArray: []
    }
    assetDeviceDetailList.forEach((adtfDeviceDetail) => {
        if (adtfDeviceDetail.assetStatus === ACTIVE && assetSubType === adtfDeviceDetail.assetSubType) {
            model.macAddressArray.push(adtfDeviceDetail.assetAttributes.mac)
            const mac = adtfDeviceDetail.assetAttributes.mac;
            const id = JSON.parse(adtfDeviceDetail.assetAttributes.deviceConfig).id;
            model.adtfDeviceInformation[mac] = {
                name: adtfDeviceDetail.assetAttributes.name,
                mac: adtfDeviceDetail.assetAttributes.mac,
                ip: adtfDeviceDetail.assetAttributes.ip,
                id: id,
                port: adtfDeviceDetail.assetAttributes.port,
                vendorAttributes: adtfDeviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                assetStatus: LOADING_STRING,
                deviceType: adtfDeviceDetail.assetAttributes.deviceType,
                assetType: adtfDeviceDetail.assetType,
                assetSubType: adtfDeviceDetail.assetSubType,
                startTime: chainWalk(() => JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).startTime, "0"),
                endTime: chainWalk(() => JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).endTime, "0"),
                reason: chainWalk(() => JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).reason, ""),
            }
            model.sorterTestPackageConfig[mac] = chainWalk(() =>
                JSON.parse(adtfDeviceDetail.assetAttributes[ADTF_CONFIG_ATTRIBUTES.SORTER_TEST_PACKAGE]), []);
            const sorterConfig = chainWalk(() =>
                JSON.parse(adtfDeviceDetail.assetAttributes[ADTF_CONFIG_ATTRIBUTES.SORTER_CONFIG]), []);
            model.sorterConfig[mac] = flattenADTFSorterConfig(sorterConfig);
        }
    });
    return model;
}

const addADTFDeviceStaticDetailsToModel = (result, model) => {
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((adtfDeviceDetail) => {
            if (adtfDeviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(adtfDeviceDetail.assetAttributes.mac)
                const mac = adtfDeviceDetail.assetAttributes.mac;
                const id = JSON.parse(adtfDeviceDetail.assetAttributes.deviceConfig).id;
                model.adtfDeviceInformation[mac] = {
                    name: adtfDeviceDetail.assetAttributes.name,
                    mac: adtfDeviceDetail.assetAttributes.mac,
                    ip: adtfDeviceDetail.assetAttributes.ip,
                    id: id,
                    port: adtfDeviceDetail.assetAttributes.port,
                    vendorAttributes: adtfDeviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                    assetStatus: LOADING_STRING,
                    deviceType: adtfDeviceDetail.assetAttributes.deviceType,
                    assetType: adtfDeviceDetail.assetType,
                    startTime: chainWalk(() => JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).reason, ""),
                }
                model.sorterTestPackageConfig[mac] = chainWalk(() =>
                    JSON.parse(adtfDeviceDetail.assetAttributes[ADTF_CONFIG_ATTRIBUTES.SORTER_TEST_PACKAGE]), []);
                const sorterConfig = chainWalk(() =>
                    JSON.parse(adtfDeviceDetail.assetAttributes[ADTF_CONFIG_ATTRIBUTES.SORTER_CONFIG]), []);
                model.sorterConfig[mac] = flattenADTFSorterConfig(sorterConfig);
            }
        });
    }
    return model;
}

async function getAdtfDeviceStatusDetails(dispatcher, model) {
    // Fetch Adtf device statuses
    const startTime = Date.now();
    const adtfStatusResponse = await getAdtfDeviceStatus(model.macAddressArray);
    const isSuccess = adtfStatusResponse.status === 200;
    const isFault = isResponseCode5xx(adtfStatusResponse.status)

    // Merge status to model and return
    if (isSuccess) {
        mergeStatusToModel(adtfStatusResponse, model)
    } else {
        model.macAddressArray.forEach((mac) => {
            model.adtfDeviceInformation[mac].assetStatus = LOADING_FAILED
        })
    }
    dispatcher({type: "RECEIVE_DATA", data: model});

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAdtfDeviceStatusDetails", isSuccess, isFault);
}

async function getADTFDeviceStaticDetails(dispatcher, model, request) {
    let pageToken = null;

    // do-while loop until we get a valid pageToken
    do {
        const startTime = Date.now();
        const getAssetsResult = await getAssets(request.nodeId, request.assetType, pageToken)
        const isSuccess = getAssetsResult.status === 200;
        const isFault = isResponseCode5xx(getAssetsResult.status)

        // Log operation
        logOperationalMetric(startTime, metricProcessName, "getAdtfDeviceDetails", isSuccess, isFault);

        if (isSuccess) {
            addADTFDeviceStaticDetailsToModel(getAssetsResult, model)
            // modifying pageToken to fetch from the latest get assets' result
            pageToken = getAssetsResult.data.pageToken
        } else {
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    } while (pageToken);
}

async function setAssetLabelDeprecatedAdtfDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAdtfDeviceDetails", true, false);
            fetchAdtfDeviceDetails(dispatcher);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteAdtfDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function updateAdtfConfiguration(dispatcher, configurations, mac, showCustomAlert) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const alias = await getAliasFromParent();
    const updatedAsset = updateConfigurationsInAdtfAssetObject(getAssetResult.data.asset, configurations, alias);
    const updateResult = await updateAsset(updatedAsset, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isUpdateSuccess = updateResult.status === 200;
    const isFault = isResponseCode5xx(updateResult.status)
    fetchAdtfDeviceDetails(dispatcher)

    // Log operation
    isUpdateSuccess ? showCustomAlert(ALERT_UPDATE_SUCCESS_ASSET_MESSAGE) : showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
    logOperationalMetric(startTime, metricProcessName, "updateAdtfConfiguration", isUpdateSuccess, isFault);
}

async function addAdtfDeviceDetails(dispatcher, request, showCustomAlert, assetSubtype) {
    const startTime = Date.now();
    addAsset(request).then(async result => {
        const isFault = isResponseCode5xx(result.status)
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAdtfDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addAdtfDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAdtfDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdateAsset = isResponseCode5xx(responseUpdateAsset.status)
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAdtfDeviceDetails", false, isFaultInUpdateAsset);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addAdtfDeviceDetails", true, false);
        }
        refreshAdtfDeviceData(dispatcher, assetSubtype);
    });
}

async function updateAdtfAsset(dispatcher, request, showCustomAlert, assetSubtype) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
    } else {
        // Update asset details
        const startTime = Date.now();
        await setAliasToRequest(request);
        const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
        preserveAssetConfigAttributes(request, chainWalk(() => getAssetResult.data.asset, null), ADTF_ASSET_TYPE);
        const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
        const isSuccess = updateAssetResponse.status === 200;
        const isFault = isResponseCode5xx(updateAssetResponse.status)
        logOperationalMetric(startTime, metricProcessName, "updateAdtfDeviceDetails", isSuccess, isFault);
    }
    
    // Refresh data regardless of success/failure
    refreshAdtfDeviceData(dispatcher, assetSubtype);
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "adtfStatusList" in response.data) {
        response.data.adtfStatusList.forEach((singleAdtfDeviceStatusDetail) => {
            model.adtfDeviceInformation[singleAdtfDeviceStatusDetail.mac].assetStatus = singleAdtfDeviceStatusDetail.status
        })
    }
}

async function updateAdtfMonitoringSchedule(dispatcher, request) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request, chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAdtfDeviceDetails", isSuccess, isFault);
    fetchAdtfDeviceDetails(dispatcher);
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

export async function updateAdtfMonitoringDetails(dispatcher, stateValues, mac){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateAdtfMonitoringSchedule(dispatcher, updatedAsset)
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/network/AdtfDeviceOverviewNetworkAPI.js